<script>
	import paramsStore from "../../../stores/paramsStore.js";
	import topicsStore from "../../../stores/data/topicsStore.js";
	import sectionsStore from "../../../stores/data/sectionsStore.js";
	import domainsStore from "../../../stores/data/domainsStore.js";
	import gamesStore from "../../../stores/data/gameCreator/gamesStore.js";
	import draftsStore from "../../../stores/data/draftsStore.js";
	import layoutStore from "../../../stores/layoutStore.js";
	import currentUserStore from "../../../stores/data/currentUserStore.js";

	import parameterize from "../../../util/parameterize.js";

	import { redirectToPost } from "../../../util/redirectTo.js";

	import Fetcher from "../../../api/Fetcher.js";

	import Button from "../../tailwind/Button.svelte";

	export let draftId;
	export let text;
	export let disabled;
	export let showTextarea;
	export let postEdit;

	let pending = false;

	$: topicSlug = $paramsStore.topicSlug;
	$: gameSlug = $paramsStore.gameSlug;
	$: sectionSlug = $paramsStore.sectionSlug;
	$: domainSlug =
		$paramsStore.domainSlug || $paramsStore.slug || $paramsStore.forumSlug;
	$: topic = $topicsStore[gameSlug ? `${gameSlug}/${topicSlug}` : topicSlug];
	$: game = $gamesStore[gameSlug];
	$: section = $sectionsStore[sectionSlug];
	$: domain = $domainsStore[domainSlug];

	$: draft = $draftsStore.find((d) => d.id === draftId);

	$: topicVerified = verifyTopic({
		topicVerification: draft?.topicVerification,
		topic,
		game,
		section,
		domain,
		currentUser: $currentUserStore,
	});

	async function setPostTag(json) {
		redirectToPost({
			topicSlug,
			postNumber: json.number,
			currentTopicSlug: topicSlug,
		});
	}

	function handleClick() {
		if (!topic || !draftId) return;
		[(pending = true)];
		if (postEdit) {
			Fetcher.editPost({ draftId }).then(handleCreatePostResponse);
		} else {
			Fetcher.createTopicIntent({ topic }).then(({ intentId }) => {
				if (!intentId) {
					pending = false;
					return;
				}
				Fetcher.createPost({ topic, draftId, intentId }).then(
					handleCreatePostResponse
				);
			});
		}
	}

	function handleCreatePostResponse(json) {
		if (!json.id) return;
		setPostTag(json);
		topicsStore.addPost({ topicSlug, post: json });
		layoutStore.toggleBottomPanel();
		draftId = null;
		text = "";
		showTextarea = true;
		draftsStore.fetchDrafts();
		pending = false;
	}

	function verifyTopic({
		topicVerification,
		topic,
		game,
		section,
		domain,
		currentUser,
	}) {
		if (!topic?.slug) return false;
		if (currentUser.settings.postTopicVerification === "None") return true;
		if (["", null, undefined].includes(topicVerification)) {
			return currentUser.settings.postTopicVerification === "Optional";
		}
		const topicVerificationArray = topicVerification.split("/");
		let topicString;
		let sectionOrGameString;
		let domainString;
		if (
			topicVerificationArray.length >= 7 &&
			topicVerificationArray.at(-2) === "p"
		) {
			topicString = topicVerificationArray.at(-3);
			sectionOrGameString = topicVerificationArray.at(-4);
			domainString = topicVerificationArray.at(-6);
		} else {
			topicString = topicVerificationArray.at(-1);
			sectionOrGameString = topicVerificationArray.at(-2);
			domainString = topicVerificationArray.at(-3);
		}
		return (
			verifyString(topicString, topic) &&
			verifyString(sectionOrGameString, section || game) &&
			verifyString(domainString, domain)
		);
	}

	function verifyString(string, object) {
		if (
			[string, object].includes(undefined) ||
			[string, object].includes(null)
		) {
			return true;
		}
		const paramString = parameterize(string);
		return (
			parameterize(object.slug).includes(paramString) ||
			parameterize(object.title).includes(paramString)
		);
	}
</script>

<Button
	className="success"
	extraClasses="btn-xs"
	disabled={disabled || pending || !topicVerified}
	on:click={handleClick}
>
	{postEdit ? "Save" : "Post"}
</Button>
